export const overrides = {
  MuiCssBaseline: {},
};
